import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/number/uint32/base/from-binary-string';
import __var_2__ from '@stdlib/number/uint32/base/rotl';
import __var_3__ from '@stdlib/number/uint32/base/rotr';
import __var_4__ from '@stdlib/number/uint32/base/to-binary-string';
import __var_5__ from '@stdlib/number/uint32/base/to-int32';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name fromBinaryStringUint32
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/uint32/base/from-binary-string}
*/
setReadOnly( ns, 'fromBinaryStringUint32', __var_1__);

/**
* @name rotl32
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/uint32/base/rotl}
*/
setReadOnly( ns, 'rotl32', __var_2__);

/**
* @name rotr32
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/uint32/base/rotr}
*/
setReadOnly( ns, 'rotr32', __var_3__);

/**
* @name toBinaryStringUint32
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/uint32/base/to-binary-string}
*/
setReadOnly( ns, 'toBinaryStringUint32', __var_4__);

/**
* @name uint32ToInt32
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/uint32/base/to-int32}
*/
setReadOnly( ns, 'uint32ToInt32', __var_5__);


// EXPORTS //
export default ns;

export { __var_1__ as fromBinaryStringUint32, __var_2__ as rotl32, __var_3__ as rotr32, __var_4__ as toBinaryStringUint32, __var_5__ as uint32ToInt32};